<template>
	<!-- Comments Section -->
	<div class="mt-4 pt-3">
		<div v-if="currentComments.length">
			<h6 class="mb-3">
				<i class="far fa-comments me-2"></i>Remarks ({{
					currentComments.length
				}})
			</h6>

			<!-- Comment 1 -->
			<div
				v-for="(comment, index) in currentComments"
				class="card mb-3 border-0 bg-light"
				:key="'comment_' + index"
			>
				<div class="card-body p-3">
					<div class="d-flex">
						<img
							src="@/assets/images/logo.png"
							alt="User"
							class="rounded-circle me-3"
							width="60"
							height="60"
						/>
						<div class="flex-grow-1">
							<div class="d-flex justify-content-between mb-1">
								<div>
									<strong>{{ comment.creator.name }}</strong>
									<small class="text-muted ms-2">(Verifier)</small>
									<!-- <small class="text-muted ms-2"
										>({{ comment.creator.designation }})</small
									> -->
								</div>
								<div>
									<small class="text-muted"
										><i class="fas fa-clock text-warning"></i>
										{{ comment.created_at }}</small
									>
									<br />
									<span
										v-if="comment.status == 'Approved'"
										class="badge bg-success"
										>Verified</span
									>
									<span v-else class="badge bg-danger">
										{{ comment.status }}</span
									>
								</div>
							</div>
							<p
								class="mb-2"
								v-html="comment.comment ? comment.comment : 'Section verified'"
							></p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="currentComments.length == 0 && user_can_approve_section"
			class="comment-form no-print"
		>
			<h5 class="mb-3">Leave a Remark</h5>
			<form method="POST">
				<div class="mb-3">
					<textarea
						class="form-control"
						rows="3"
						id="comment"
						name="comment"
						v-model="comment"
						placeholder="Write your remarks here..."
					></textarea>
				</div>
				<div class="d-flex justify-content-end align-items-end">
					<button
						type="submit"
						class="btn btn-danger me-1"
						@click.prevent="saveComment('rejected')"
					>
						<span v-if="isLoading">Please wait...</span>
						<span v-else>Reject</span>
					</button>
					<button
						type="submit"
						class="btn btn-info"
						@click.prevent="saveComment('approved')"
					>
						<span v-if="isLoading">Please wait...</span>
						<span v-else>Verify</span>
					</button>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import Swal from "sweetalert2";
import { userHasPermission } from "@/utils/permissions";
import ListComment from "./ListComment.vue";

export default {
	comments: {
		ListComment,
	},
	props: {
		section: {
			type: String,
			required: true,
		},
		comments: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			isLoading: false,
			comment: null,
			currentComments: [],
		};
	},

	computed: {
		user_can_approve_section() {
			return userHasPermission("party-registration-create");
		},
	},

	methods: {
		saveComment(status) {
			if (status == "rejected" && this.comment == null) {
				return Swal.fire({
					text: "Comment must be provided while rejecting a section",
					icon: "error",
				});
			}

			let payload = {
				partyID: this.$route.params.id,
				section: this.section,
				comment: this.comment,
				status: status,
			};

			let _status = status == "approved" ? "verify" : "reject";
			let title =
				status == "approved"
					? "Are you sure you have verified this section?"
					: "Are you sure you want to reject this section?";

			Swal.fire({
				title: title,
				text: "You won't be able to revert this!",
				icon: "question",
				showCancelButton: true,
				confirmButtonColor: "#29623c",
				cancelButtonColor: "#d33",
				confirmButtonText: `Yes, ${_status}!`,
			}).then((result) => {
				if (result.isConfirmed) {
					this.isLoading = true;

					this.$store
						.dispatch("parties/approveApplicationSection", payload)
						.then((resp) => {
							if (resp.status_code === 200) {
								this.comment = null;
								this.setComments(resp.data.approvals);
								Swal.fire({
									icon: "success",
									title: "Verified",
									text: "Section has been verified!",
								});
								this.isLoading = false;
							} else {
								Swal.fire({
									icon: "error",
									title: "Error",
									text:
										resp.response.data.errors.message ??
										"Unable to complete action",
								});

								this.isLoading = false;
							}
						});
				}
			});
		},

		setComments(comments) {
			this.currentComments = comments.filter(
				(comment) => comment.section == this.section
			);
		},
	},

	mounted() {
		this.setComments(this.comments);
	},
};
</script>
<style>
@media print {
	.no-print {
		display: none !important;
	}
}
</style>
